import { lighten } from "@material-ui/core/styles/colorManipulator";
import styled from "styled-components";
import BaseButton from "./BaseButton";

export default styled(BaseButton)`
    border: 1px solid ${(props) => lighten(props.theme.palette.grey[20], 0.1)}; /* stylelint-disable-line */
    text-transform: none;
`;
